import AliasEqualsSelector from '../AliasEqualsSelector';
import SaleLocatorTypeEqualsComparator from './SaleLocatorTypeEqualsComparator';
const options = [{
  name: 'Original Locator',
  value: 'original'
}, {
  name: 'Replacement Locator',
  value: 'replacement'
}];
export default AliasEqualsSelector.create(SaleLocatorTypeEqualsComparator, options);